import { Component, OnInit } from '@angular/core';
import { FormControl, UntypedFormGroup, UntypedFormBuilder, Validators, FormGroupDirective   } from '@angular/forms';
import  { pdf } from './andra-land-record-pdf'
@Component({
  selector: 'wl-land-record-update-new',
  templateUrl: './land-record-update-new.component.html',
  styles: []
})
export class LandRecordUpdateNewComponent implements OnInit {
  landRecordForm: UntypedFormGroup;
  reportLink: any;

  constructor( private fb: UntypedFormBuilder,) { 
    this.landRecordForm = this.fb.group({
      district: ['', Validators.required],	
      mandal: ['',Validators.required],	
      villageName: ['', Validators.required],
      surveyNumber: ['', Validators.required],	
    
    
    });
    this.reportLink = 'data:application/pdf;base64,' + pdf;
  }

  ngOnInit() {
  }

  
  mandalSelected(value) {
    console.log(value)
    this.landRecordForm.get("villageName").setValue("Kondagunta");
    this.landRecordForm.get("surveyNumber").setValue("402-2");
    
  }

  landRecordUpdate(formDirective: FormGroupDirective){
    const downloadLink = document.createElement("a");
    const fileName = "Land-Record.pdf";
    downloadLink.href = this.reportLink;
    downloadLink.download = fileName;
    downloadLink.click();
    this.landRecordForm.reset();
    formDirective.resetForm(); 
  }

}
